export default "__VITE_ASSET__CxvhzeIo__"